import React from 'react';
/* globals Rollbar */

export default props => {
  if (props.error) Rollbar.error(props.error);
  return <div style={{ height: 500 }} />;
};
